import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from '../index'
import type { IClientUID } from '../clients'

export async function flashDevice(clientId: IClientUID): Promise<ApiResponse<undefined>> {
    const response = await fetch(`${HOST_URL}flash-device`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId }),
    })
    const result = (await response.json()) as ApiResponse<undefined>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
